import React, { useEffect, useState } from "react";
import TestIllustration from "../../assets/Icons/labimage.svg";
import home from "../../assets/Icons/Home.svg";
import center from "../../assets/Icons/Vector.svg";
import blood from "../../assets/Icons/syringe.svg";
import notes from "../../assets/Icons/hour.svg";
import required from "../../assets/Icons/requred.svg";
import check from "../../assets/Icons/fact_check.svg";
import { message, Tooltip } from "antd";
import { APP_ROUTES } from "../../PageRouting/pageRoutes";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import { AddtoCart, getCartDetails } from "../../Redux/actions/cartActions";
import {
  createCartOrderDtlItem,
  createCartOrderHdrItem,
  getCurrentTime,
} from "../../Shared/CartHelper";

function LabTestCard({ test, deliverable, address, patientMembershipDet }) {
  const [isTestThereInCart, setIsTestThereInCart] = useState(false);
  const dispatch = useDispatch();
  const { cartData } = useSelector((state) => state.cart);
  const { patientData } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!cartData) return;
    const { cartOrderHdr } = cartData;
    const labData = cartOrderHdr?.find((item) => item.orderType === "LAB");
    if (labData) {
      const labItems = labData?.cartOrderDtl;
      if (labItems && labItems?.length !== 0) {
        const isLabTestThereInCart = labItems?.find(
          (item) => item.orderCode === test.testCode,
        );
        if (isLabTestThereInCart) {
          setIsTestThereInCart(true);
        }
      }
    }
  }, [cartData]);

  const calculateDiscountedPrice = (labTest, patientMembershipDet) => {
    if (!patientMembershipDet) return labTest?.listPrice;

    const membershipObj = patientMembershipDet.find(
      (m) => m.serviceCategory === labTest?.testType.toUpperCase(),
    );

    const currentPrice = labTest?.listPrice || 0;
    const discountAmount = Math.floor(
      currentPrice * (membershipObj?.discountPercentage / 100),
    );
    const finalMedPrice = currentPrice - discountAmount;
    return finalMedPrice?.toFixed(2);
  };

  const calculateDiscountAmount = (labTest, patientMembershipDet) => {
    if (!patientMembershipDet) return 0;
    const membershipObj = patientMembershipDet.find(
      (m) => m.serviceCategory === labTest?.testType.toUpperCase(),
    );

    const currentPrice = labTest?.listPrice || 0;
    const discountAmount = Math.floor(
      currentPrice * (membershipObj?.discountPercentage / 100),
    );
    return discountAmount;
  };

  const handleAddToCart = async ({ itemObj, type }) => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }

    if (!deliverable) {
      message.error(
        "Lab service is not available at your location. Please enter pincode / try another pincode.",
      );
      return;
    }

    if (!patientData) {
      message.error("Please login as a patient");
      return;
    }

    if (!itemObj) return;

    if (!address) {
      message.error("Please select/add your delivery address.");
      return;
    }

    const now = getCurrentTime();
    const existingCartId = cartData?.cartId;
    const cartHdrs = [...(cartData?.cartOrderHdr || [])];
    const itemCode = itemObj.testCode;
    const itemName = itemObj.testName;
    const itemCategory = itemObj?.category || itemObj?.testType?.toUpperCase();
    const vendorId = itemObj.labCode;
    const price = parseFloat(itemObj.listPrice || 0);

    const existingHdr = cartHdrs.find((hdr) => hdr.orderType === type);
    let payload;

    if (!existingCartId) {
      const dtlItem = createCartOrderDtlItem({
        item: {
          code: itemCode,
          name: itemName,
          labCategory: itemCategory,
          price,
          vendorId,
        },
        type,
        patientId: patientData.patientId,
        user: patientData,
      });

      payload = {
        cartOrderHdr: [
          createCartOrderHdrItem({
            Acc_branch: { acc_Id: itemObj.labCode, bran_Id: itemObj.branchId },
            dtlItem,
            account: address,
            user: patientData,
            patientId: patientData.patientId,
            type,
          }),
        ],
        cartType: 1,
        patientId: patientData.patientId,
        paymentType: "",
        status: 1,
      };
      payload.cartOrderHdr[0].labCategory = "External Lab Test";

      let grandTotalAmount = payload?.cartOrderHdr?.reduce((sum, order) => {
        return sum + (order?.paidAmount || 0);
      }, 0);

      payload = {
        ...payload,
        totalAmount: grandTotalAmount,
      };
    } else {
      const newHdrs = cartHdrs.map((hdr) => {
        if (hdr.orderType !== type) return hdr;

        const existingItem = hdr.cartOrderDtl.find(
          (i) => i.orderCode === itemCode,
        );
        console.log(existingItem, " testing exis ", itemCode, itemObj);
        let updatedDtl = [...hdr.cartOrderDtl];
        if (existingItem) {
          updatedDtl = updatedDtl.map((i) =>
            i.orderCode === itemCode
              ? {
                  ...i,
                  quantity: i.quantity + 1,
                  amount: (i.quantity + 1) * i.unitPrice,
                  paidAmount: (i.quantity + 1) * i.unitPrice,
                  modifiedDate: now,
                  orderState: "U",
                }
              : i,
          );
        } else {
          const newDtlItem = createCartOrderDtlItem({
            item: {
              code: itemCode,
              name: itemName,
              labCategory: itemCategory,
              price,
              vendorId,
            },
            type,
            patientId: patientData.patientId,
            user: patientData,
            cartId: existingCartId,
          });
          updatedDtl.push(newDtlItem);
        }

        const totalAmt = updatedDtl.reduce(
          (sum, i) => sum + Number(i.amount),
          0,
        );
        const totalPaid = updatedDtl.reduce(
          (sum, i) => sum + Number(i.paidAmount),
          0,
        );

        return {
          ...hdr,
          cartOrderDtl: updatedDtl,
          amount: Number(parseFloat(totalAmt).toFixed(2)),
          paidAmount: Number(parseFloat(totalPaid).toFixed(2)),
          modifiedDate: now,
        };
      });

      if (!existingHdr) {
        const dtlItem = createCartOrderDtlItem({
          item: {
            code: itemCode,
            name: itemName,
            labCategory: itemCategory,
            price,
            vendorId,
          },
          type,
          patientId: patientData.patientId,
          user: patientData,
          cartId: existingCartId,
        });

        const cartHdrObject = createCartOrderHdrItem({
          Acc_branch: { acc_Id: itemObj.labCode, bran_Id: itemObj.branchId },
          dtlItem,
          account: address,
          user: patientData,
          patientId: patientData.patientId,
          type,
        });
        cartHdrObject.labCategory = "External Lab Test";
        newHdrs.push(cartHdrObject);
      }

      let grandTotalAmount = newHdrs?.reduce((sum, order) => {
        return sum + (Number(order?.paidAmount) || 0);
      }, 0);

      payload = {
        ...cartData,
        cartId: existingCartId,
        cartOrderHdr: newHdrs,
        modifiedDate: now,
        totalAmount: grandTotalAmount,
      };
    }

    try {
      const updatedCart = await dispatch(AddtoCart(payload));
      const cartPayload = { patientId: patientData.patientId };
      dispatch(getCartDetails(cartPayload));
      message.success("LabTest added to cart successfully.");
    } catch (e) {
      console.log(e);
    }
  };

  const handleLabDet = () => {
    if (!patientData && !patientData?.patientId) {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
      return;
    }

    if (deliverable) {
      navigate(APP_ROUTES.LABTESTDETAILS, { state: { labTest: test } });
    } else {
      message.error(
        "Lab service is not available at your location. Please enter pincode / try another pincode.",
      );
    }
  };

  return (
    <>
      <div
        key={test.id}
        className="w-[100%] border rounded-md p-3 flex gap-5"
        onClick={handleLabDet}
      >
        <div className="flex w-full justify-between">
          <div className="flex gap-3">
            <div className="border rounded-md flex justify-center items-center w-20 h-20">
              <img src={TestIllustration} alt="" />
            </div>
            <div>
              <p className="font-sans font-semibold text-sm text-black">
                <Tooltip title={test.testDisplayName}>
                  {test.testDisplayName && test.testDisplayName.length > 50
                    ? `${test.testDisplayName.slice(0, 50)}...`
                    : test.testDisplayName}
                </Tooltip>
              </p>
              <div className="flex gap-3 mt-2">
                <p className="font-sans font-medium text-xs text-[#333333]">
                  {test.noOfTestIncluded}
                </p>
                {test.home && (
                  <div className="border rounded-md w-20 border-[#EFFBFF] bg-[#B9EFFF] flex gap-2 items-center justify-center py-0.5">
                    <img src={home} alt="" />
                    <p className="text-xs font-sans font-semibold">Home</p>
                  </div>
                )}
                {test.center && (
                  <div className="border rounded-md w-20 border-[#EFFBFF] bg-[#DDD7FF] flex gap-2 items-center justify-center py-0.5">
                    <img src={center} alt="" />
                    <p className="text-xs font-sans font-semibold">Lab</p>
                  </div>
                )}
              </div>
              <div className="flex justify-start gap-5 mt-3">
                <div className="flex gap-2 items-center justify-center">
                  <img src={blood} alt="" />
                  <p className="text-xs font-sans font-semibold">
                    {test.specimen}
                  </p>
                </div>
                <div className="flex gap-2 items-center justify-center">
                  <img src={notes} alt="" />
                  <p className="text-xs font-sans font-semibold">{test.tat}</p>
                </div>
                <div className="flex gap-2 items-center justify-center">
                  <img src={required} alt="" />
                  <p className="text-xs font-sans font-semibold">
                    {/* {test.prescription} */}
                  </p>
                </div>
                <div className="flex gap-2 items-center justify-center">
                  <img src={check} alt="" />
                  <p className="text-xs font-sans font-semibold">
                    {test.preTestInfo}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-[30%] flex flex-col items-end justify-center">
            {patientMembershipDet ? (
              <div className="flex items-center gap-3 my-2 text-sm">
                <span className="text-lg font-semibold text-gray-900">
                  ₹{calculateDiscountedPrice(test, patientMembershipDet)}
                </span>
                <span className="line-through text-gray-400">
                  ₹{test?.listPrice}
                </span>
                <span className="text-green-600">
                  (Save ₹
                  {calculateDiscountAmount(test, patientMembershipDet) || "-"})
                </span>
              </div>
            ) : (
              <p className="font-semibold font-sans text-base text-black">
                <span className="text-sm font-normal text-gray-400 mr-0.5">
                  INR
                </span>{" "}
                {test.listPrice}/-
              </p>
            )}
            <button
              disabled={isTestThereInCart}
              className=" bg-[#189FAA]  text-white px-10 py-1 font-sans font-semibold text-sm rounded hover:bg-teal-700 disabled:bg-brand-successColor"
              onClick={(e) => {
                e.stopPropagation();
                handleAddToCart({
                  itemObj: test,
                  type: "LAB",
                });
              }}
            >
              {isTestThereInCart ? "Added" : "Add to cart"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default LabTestCard;
